import styled from 'styled-components';

import { DatePicker } from 'components/modules/Insurance/components/DatePicker/DatePicker';
import { MAX_DATE, MIN_DATE } from 'components/modules/Insurance/Insurance.constants';
import { TextInput, TextInputMasked } from 'components/modules/Insurance/Insurance.styles';
import * as CarInstanceConstants from 'store/carInstance/constants';
import * as InsuranceConstants from 'store/insurance/constants';

import { NUMBER_MASK } from './PtsInformation.constants';

export const PtsNumberInput = styled(TextInputMasked).attrs({
  label: 'Серия и номер',
  mask: NUMBER_MASK,
  name: CarInstanceConstants.PTS_VALUE_FIELDS.NUMBER,
})``;

export const PtsIssueDatepicker = styled(DatePicker).attrs({
  label: 'Дата выдачи',
  name: CarInstanceConstants.PTS_VALUE_FIELDS.ISSUE_DATE,
  maxDate: MAX_DATE,
  minDate: MIN_DATE,
})``;

export const MarkAsPTSInput = styled(TextInput).attrs({
  label: 'Марка как в ПТС',
  name: InsuranceConstants.DATA_FIELDS.MARK_AS_PTS,
})``;

export const ModelAsPTSInput = styled(TextInput).attrs({
  label: 'Модель как в ПТС',
  name: InsuranceConstants.DATA_FIELDS.MODEL_AS_PTS,
})``;
